import React from "react";
import { css } from "@linaria/core";
import { colors } from "@ui/Theme";
import Text from "@ui/Text";
import classNames from "classnames";
import t from "../../../i18n";

interface NoDataPeriodPlaceholderWidgetProps {
  className?: string;
}

const NoDataPeriodPlaceholderWidget = ({ className }: NoDataPeriodPlaceholderWidgetProps) => (
  <div className={classNames(noData, className)}>
    <Text type="body2">{t("project.fault_events.widgets.no_data_in_period_placeholder")}</Text>
  </div>
);

//#region CSS
const noData = css`
  place-items: center;
  color: ${colors.carbon500};
  height: 100%;
  display: grid;
`;

export default NoDataPeriodPlaceholderWidget;
